/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled,  { css } from 'styled-components';
import Colors from 'constants/Colors';
import { Breakpoints } from 'constants/Breakpoints';
import { mediaHelperMaxWidth } from "../../utils/src";
import { FiraSansBold } from 'components/Text/Text';
import {darken} from 'polished';

export const Dialog = styled.div`
  position: absolute; 
  z-index: 9999999999; 
  padding-top: 30vh;
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto; 
  ${({ canShow }) =>
  canShow
    ? css`
        display: block;
        `
    : `display: none;`
  }
`;

export const DialogBody = styled.div`
  background-color: #fefefe;
  box-shadow: 0px 1px 5px 2px ${Colors.GRAY[3]};
  width: 50vw;
  height: 90vh;
  min-height: 100px;
  border-radius: 4px;
  
  position: fixed;
  bottom: 40px;
  right: 0;

  ${mediaHelperMaxWidth.md`
    width: 100%;
    height: 100%;
    position: fixed;
    top:0;
    bottom: 0;
  `}
  display: flex;
  overflow: hidden;
  flex-direction: column;
`;

export const SearchContent = styled.div `
  height: 55px;
  min-height: 55px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: ${Colors.BLUE};
  box-shadow: 0 2px 1px -2px rgba(0,0,0,0.4);
`;

export const Scrollbox = styled.div` 
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2px 10px;
  width: 100%;
  height: 100%;
  
  ::-webkit-scrollbar{
    background:${Colors.WHITE};
    width:8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
  `;

  export const MessageContainer = styled.div`
    background-color: #fefefe;
    bottom: ${({ isUploading }) => isUploading ? '180px' : '120px'};
    left: 0;
    width: 100%;
    border-top: 2px solid #ccc;
    bottom:0
    padding-bottom: 10px;
  `;

  export const ContentIcons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    padding-top: 10px;

    div {
     position: absolute;
     right: 0.7rem;
    }
  `;

  export const ContentIcons2 = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    padding-top: 10px;
    position: absolute;
    right: 0.7rem;
  `;


  export const ContentTextArea = styled.div`
    padding: 1px 2px;

    & > a { 
      margin: 2px 12px;
      text-decoration: none;
      color: #000;
    }
  `;

  export const RowMessage = styled.div`
    width: 100%;
    display: table;
    margin: 20px 0;
  `; 

  export const Container = styled.div`
    position: relative;

    &:last-child {
      margin-bottom: 60px;
    }
  `;

  export const BallonMessageArrowLeft = styled.div`
    word-break: break-word;
    background: #FFFFFF;
    padding: 10px;
    position: relative;
    top: 20px;
    left: 10px;
    max-width: 95%;
    float: left;
    min-height: 80px;
    border: 2.5px solid #d3d3d5;
    border-radius: 10px;
    
    &::before {
      content:'';
      position: absolute;
      width: 20px;
      height: 20px;
      left: -11.2px;
      top: 16px;
      background: #FFFFFF;
      transform: rotate(45deg);
      border-left: 2.5px solid #D3D3D5;
      border-bottom: 2.5px solid #D3D3D5;
    }

    
    @media(max-width: ${Breakpoints.sm}) {
      max-width: 95%;
      width: 95%;
    }
  `;  

  export const BallonMessageArrowRight = styled.div`
    word-break: break-word;
    background: #FBFBFB;
    padding: 10px;
    position: relative;
    top: 20px;
    right: 10px;
    max-width: 95%;
    float: right;
    min-height: 80px;
    border: 2.5px solid #D3D3D5;
    border-radius: 10px;
    
    &::before {
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      right: -11.2px;
      top: 16px;
      background: #FBFBFB;
      transform: rotate(45deg);
      border-right: 2.5px solid #D3D3D5;
      border-top: 2.5px solid #D3D3D5;
    }

    @media (max-width: ${Breakpoints.sm}) {
      max-width: 95%;
      width: 95%;
    }
  `;

  export const Comp = styled.div `
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;
    margin: auto;
    padding-top: 5px;
    position: absolute;
    right: 55px;
    top: 0;
    width: 75%;
  `;


  export const RowAttchments = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
  `;

  export const AttachmentFiles = styled.a`
    text-decoration: none;
    color: #000;
    margin: 2px 12px;
    font-size: 0.8rem;

    &:visited {
      color: #000;
    }
  `


  export const NewRowAttchments = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 120px;
  `;

  export const BoxAttachment = styled.a`
    display: flex;
    align-items: center;
    margin-left: 16px;
    border: 1px solid rgba(200,200,200, 0.5);
    border-radius: 4px;
    padding: 5px;
    text-decoration: none;
  `;

  export const DateTimeText = styled.span`
    font-size: 8px;
    position: absolute;
  
    ${({isInternal}) => isInternal ? 'right' : 'left'}: 20px;
  `; 

  const generateStyle = (color, bg, bgFocus, bgActive, args = []) => {
    return css`
    color: ${color};
    background-color: ${bg};
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      background-color: ${bgFocus};
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
    }
    &:active:not(:disabled) {
      background-color: ${bgActive};
    }
    ${args.length >= 1 ? args.join('\n') : ''}
    `;
  }
  
  const primaryMixin = generateStyle(Colors.WHITE, Colors.BLUE, darken(0.1, Colors.BLUE), darken(0.2, Colors.BLUE));
  const secundaryMixin = generateStyle(Colors.WHITE, Colors.PURPLE, darken(0.1, Colors.PURPLE), darken(0.2, Colors.PURPLE));
  const thirdMixin = generateStyle(Colors.WHITE, Colors.GRAY[6], darken(0.1, Colors.GRAY[0]), darken(0.2, Colors.GRAY[3]));
  
  
  /* const outlinePrimaryMixin = generateStyle(Colors.WHITE,Colors.GRAY[6], darken(0.1, Colors.GRAY[0]), darken(0.2, Colors.GRAY[3]),
  [`border: 1px ${({ dashed }) => (dashed ? 'dashed' : 'solid')} ${Colors.SECONDARY};`,`${FiraSansBold}`])
   */
  
  
  const outlinePrimaryMixin = css`
  border: 1px ${({ dashed }) => (dashed ? 'dashed' : 'solid')} ${Colors.BLUE};
  ${FiraSansBold}
    color: ${Colors.WHITE};
    padding: 4px 16px;
    text-transform: none;
    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      color: white;
      border-color: ${Colors.BLUE};
      background: ${Colors.BLUE};
    }
    &:active:not(:disabled) {
      background-color: ${darken(0.2, Colors.BLUE)};
    }
  `;
  
  const forthMixin = css`
    padding: 0.75rem 0.95rem;
    color: ${Colors.GRAY[6]};
  `;
  
  const grayTextMixin = css`
    padding: 8px 0;
    color: ${Colors.GRAY[0]};
    &:active:not(:disabled) {
      color: ${Colors.GRAY[3]};
    }
  `;
  
  const noBorderPrimaryMixin = css`
    color: ${Colors.BLUE};
    padding: 6px 16px;
    ${FiraSansBold}
    text-transform: none;
    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      color: ${Colors.PRIMARY};
    }
    &:active:not(:disabled) {
      color: ${Colors.PRIMARY};
    }
  `;
  
  // Size mixin
  const smallMixin = css`
    height: 32px;
  `;
  
  
  export const Button = styled.button`
  padding: 0.10rem 0.20rem;
  width: auto;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 42px;
  white-space: nowrap;
  margin: 10px 10px 0px 10px;

  ${FiraSansBold}

  border: 0 none;
  border-radius: 8px;
  background: transparent;

  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease, border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;

  text-align: center;
  &:focus,
  &:active { outline: none; }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  ${({ outlinePrimary }) => outlinePrimary && outlinePrimaryMixin}
  ${({ text }) => text && grayTextMixin}
  ${({ primary }) => primary && primaryMixin}
  ${({ secundary }) => secundary && secundaryMixin}
  ${({ third }) => third && thirdMixin}
  ${({ noBorderPrimary }) => noBorderPrimary && noBorderPrimaryMixin}
  ${({ forth }) => forth && forthMixin}

  ${({ sm }) => sm && smallMixin}

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}

  @media(min-width: ${Breakpoints.sm}) {  
    padding: .75rem 3.75rem;
    width: auto;
  }
  @media (min-width: ${Breakpoints.xl}) and (max-width: ${Breakpoints.xxl}) {  
    padding: .75rem 2.5rem;
    width: 100%;
    font-size: 13px;
    text-align: center;
    
  }

  @media (min-width: ${Breakpoints.xxs}) and (max-width: ${Breakpoints.lg}) {  
    padding: .75rem 2.5rem;
    width: 100%;
    font-size: 16px;
    text-align: center;
    
  }

`;
